import React from 'react'

import loadable from '@loadable/component'
import { Route, useRouteMatch } from 'react-router'

import {
  photoViewerFullPath,
  photoViewerModalPath,
} from 'components/page/PhotoViewer/PhotoViewer.paths'
import { PhotoViewerLoadable } from 'components/page/PhotoViewer/PhotoViewerLoadable'
import { matchCouplePath } from 'components/page/RatingWave/Rating.paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'

const MatchingLoadable = loadable(
  async () => (await import('components/block/Matching/Matching')).Matching
)

const PhotoViewerRatingLoadable = loadable(
  async () =>
    (await import('components/page/PhotoViewer/PhotoViewerRating'))
      .PhotoViewerRating
)

/**
 * Пока сомневаюсь что надо тут оставлять
 * Сюда перенести router для фотовьювера
 */
export const Routes = () => {
  const { path } = useRouteMatch()

  return (
    <>
      <Route
        path={mergeAllUrls(path, photoViewerFullPath)}
        component={PhotoViewerRatingLoadable}
        exact={true}
      />
      <Route
        path={mergeAllUrls(path, photoViewerModalPath)}
        component={PhotoViewerLoadable}
        exact={true}
      />
      <Route
        path={mergeAllUrls(path, matchCouplePath)}
        component={MatchingLoadable}
        exact={true}
      />
    </>
  )
}
